import type { LockoutPayload } from './loginFormTypes';

export const isLockoutPayload = (data: unknown): data is LockoutPayload => {
  if (!data || typeof data !== 'object') return false;
  const record = data as Record<string, unknown>;
  return (
    typeof record.error === 'string' &&
    (typeof record.locked_until === 'string' ||
      typeof record.retry_after_seconds === 'number')
  );
};

export const lockoutDateFromPayload = (
  payload: LockoutPayload
): Date | null => {
  if (payload.locked_until) {
    const lockedUntil = new Date(payload.locked_until);
    return Number.isNaN(lockedUntil.getTime()) ? null : lockedUntil;
  }

  if (typeof payload.retry_after_seconds === 'number') {
    return new Date(Date.now() + payload.retry_after_seconds * 1000);
  }

  return null;
};

export const parseJsonResponse = async (
  response: Response
): Promise<{ ok: true; data: unknown } | { ok: false; errorKey: string }> => {
  const contentType = response.headers.get('content-type');
  if (!contentType?.includes('application/json')) {
    const responseText = await response.text();
    console.error('Non-JSON login response:', responseText);
    return { ok: false, errorKey: 'auth.errors.server_non_json' };
  }

  return { ok: true, data: await response.json() };
};
